export const appendQueryToUrl = (
  url: string,
  linknav?: string
): string => {
  if (linknav && url) {
    return url.includes('?') ? `${url}&linknav=${linknav}` : `${url}?linknav=${linknav}`;
  }
  return url;
};
